import React from "react"
import moment from "moment"
import { Table } from "react-bootstrap"
import { fillingZeroUtility, formatCurrency } from "../../../lib/utils"
import AlertModal from "../../fragments/AlertModal"
import CaptionTable from "../../fragments/CaptionTable"
import { Link } from "react-router"

export default class RenderPayments extends React.Component {

  state = {
    payment: null,
  }

  showPayment = payment => this.setState({ payment })

  closeDisplayForm = () => this.setState({ payment: null })

  renderTr = (title, value, className) => <tr className={ className }>
    <td className="strong">{ title }</td>
    <td>{ value }</td>
  </tr>

  renderPaymentDetails = payment => {

    const { investor: { name }, currencyCode, amount, paymentType, createdOn } = payment

    return (
      <Table responsive striped bordered condensed hover>
        <tbody>

          <tr>
            <td width="30%" className="strong">Investor name</td>
            <td>{ name }</td>
          </tr>

          { this.renderTr('Currency', currencyCode) }

          { this.renderTr('Amount', formatCurrency(amount)) }

          { this.renderTr('Payment Mode', paymentType) }

          { this.renderTr(
            'Created on',
            createdOn ? moment(createdOn).format('lll') : '',
            'gray'
          )}
        </tbody>
      </Table>
    )
  }

  renderThs = () => <tr>
    <th className="gray font-size-13">Date</th>
    <th>Currency</th>
    <th>Amount</th>
  </tr>

  getData = payments => payments.map((item, index) => {

    const { currencyCode, amount, createdOn } = item

    return <tr key={ index } className="cursor-pointer" title="Show details"
      onClick={_ => this.showPayment(item)}>

      <td className="gray">
        <small>{ createdOn ? moment(createdOn).format('ll') : '' }</small>
      </td>

      <td>{ currencyCode }</td>

      <td>{ formatCurrency(amount) }</td>
    </tr>
  })

  detailsLink = id => `/financiers/investors/payments/${id}/detail`

  render() {

    const { payments } = this.props
    if (!payments) return null

    const { payment } = this.state,
    title = payment ? <span>Payment &nbsp; <Link to={ this.detailsLink(payment.id) }>
      #{ payment.id }</Link></span> : ''

    return (
      <div>
        <Table striped condensed hover responsive>

          <CaptionTable text={`Payments (${ fillingZeroUtility(payments.length) })`} />

          <tbody>
            { this.renderThs() }
            { this.getData(payments) }
          </tbody>
        </Table>

        { !!payment &&
        <AlertModal
          show={ !!payment }
          title={ title }
          body={ this.renderPaymentDetails(payment) }
          close={ this.closeDisplayForm }
        />}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Financiers/Investors/RenderPayment.js